import { Typography } from "@mui/material";
import React from "react";

import theme from "Theme/AppTheme";

interface SubtitleProps {
    align?: "left" | "center";
}

export function Subtitle({
    align = "left",
    children,
}: React.PropsWithChildren<SubtitleProps>) {
    return (
        <Typography
            component="span"
            variant="subtitle2"
            align={align}
            sx={{
                fontWeight: theme.typography.fontWeightRegular,
                fontSize: 14,
                lineHeight: "20px",
                color: theme.palette.gray[500],
            }}
        >
            {children}
        </Typography>
    );
}
